import { Separator } from '@/shared/ui/Separator'

import { TooltipIconDetails } from '../types/TooltipIconDetails'
import { tooltipIconColorMap } from '../utils/TooltipIconColorConfig'
import { getTooltipIcon } from '../utils/getTooltipIcon'

interface TooltipIconsListProps {
	tooltipIconsDetails: TooltipIconDetails[] | undefined
	showSeparator: boolean
}

export const TooltipIconsList = ({
	tooltipIconsDetails,
	showSeparator
}: TooltipIconsListProps) => {
	if (!tooltipIconsDetails || tooltipIconsDetails.length === 0) return null

	return (
		<div>
			{showSeparator && (
				<Separator className="mb-3 border-t-2 border-gray-200" />
			)}
			<div className="flex flex-col gap-2">
				<div className="flex flex-col gap-2">
					{tooltipIconsDetails.map(item => {
						const TooltipIcon = getTooltipIcon(item.tooltipIconType)
						const textColorVar = tooltipIconColorMap[item.tooltipIconType]

						return (
							<div
								key={item.tooltipIconType}
								className="flex items-start gap-2"
							>
								<TooltipIcon
									className="h-4 w-4 flex-shrink-0"
									style={{ color: `var(${textColorVar})` }}
								/>
								<p className="ts-8 mt-0.5 text-left font-normal whitespace-pre-line text-gray-400">
									{item.tooltipIconDescription}
								</p>
							</div>
						)
					})}
				</div>
			</div>
		</div>
	)
}
